<template>
    <div class="filter_container">
        <h5 style="padding:10px 0px;">預約數據</h5>
        <div class="filter">
            <date-picker 
                :lang="lang"
                style="margin-right:5px;"
                v-model="start_at"
                placeholder="開始日期"
                format="YYYY-MM-DD"
            >
            </date-picker>
            <date-picker 
                :lang="lang"
                style="margin-right:5px;"
                placeholder="結束日期"
                v-model="end_at"
                format="YYYY-MM-DD"
            >
            </date-picker>

            <b-button
                v-on:click="getData"
            >
                取得資料
            </b-button>

        </div>

        <div></div>

        <div style="width: 100%;margin-top:1em;">
            <b-card no-body >
                <b-tabs card>

                    

                    <b-tab :title="selected_supplier.name" v-if="selected_supplier !== null && (mode === 'supplier' || mode === 'store')" v-on:click="back('supplier')" :active="selected_supplier !== null && selected_store === null">
                        <b-card-text>

                            <div style="display:flex; flex-direction:row;align-items: center;">

                                <!-- 圖表 -->
                                <div style="width:100%;min-width:50%;">
                                    <div style="height:300px;" class="chart-container">
                                        <LineChartGenerator
                                            :chart-options="chartOptions"
                                            :chart-data="this.chart_view['supplier']"
                                        />
                                    </div>
                                </div>

                                <!-- 統計數據 -->
                                <div style="width:20%" >
                                    <b-list-group>
                                        <b-list-group-item v-for="(item, idx) in Object.keys(total_view.supplier)" :key="idx">
                                            <template v-if="total_view.text_key_mapper[item] !== undefined">
                                            <span class="float-left">{{total_view.text_key_mapper[item] }}：</span>

                                            <span class="float-right mr-2" v-if="item.indexOf('average') === -1">{{total_view.supplier[item]}}</span>
                                            <span class="float-right mr-2" v-else>{{timeFormat(total_view.supplier[item])}}</span>
                                            </template>

                                        </b-list-group-item>
                                    </b-list-group>
                                </div>

                            </div>

                            <div>
                                <!-- 報表 -->
                                <b-table
                                    style="margin-top:1em;"
                                    :items="table_view.supplier.items" :fields="table_view.supplier.columns"
                                >
                                    <template v-slot:head()="data">
                                        <span 
                                            v-b-tooltip.hover :title="data.field.tooltip"
                                        >
                                            {{ data.label }}
                                            <i  
                                                v-if="data.field.tooltip !== undefined" 
                                                class="bi bi-info-circle">
                                            </i>
                                        </span>
                                    </template>

                                    <template v-slot:cell(name)="{ item }">
                                        <span style="color: #68acef; cursor:pointer;"
                                            @click="goStore(item)"
                                        >
                                            {{item.name}}
                                        </span>
                                    </template>

                                    <template v-slot:cell(average_response_time)="{ item }">
                                        <span 
                                        >
                                            {{timeFormat(item.average_response_time)}}
                                        </span>
                                    </template>

                                    <template v-slot:cell(average_done_time)="{ item }">
                                        <span 
                                        >
                                            {{timeFormat(item.average_done_time)}}
                                        </span>
                                    </template>

                                </b-table>
                            </div>
                        </b-card-text>
                    </b-tab>


                    <b-tab :title="selected_store.name" v-if="selected_store !== null" :active="selected_store !== null && selected_supplier !== null">
                        <b-card-text>

                            <div style="display:flex; flex-direction:row;align-items: center;">

                                <!-- 圖表 -->
                                <div style="width:100%;min-width:50%;">
                                    <div style="height:300px;" class="chart-container">
                                        <LineChartGenerator
                                            :chart-options="chartOptions"
                                            :chart-data="this.chart_view['store']"
                                        />
                                    </div>
                                </div>

                                <!-- 統計數據 -->
                                <div style="width:20%" >
                                    <b-list-group>
                                        <b-list-group-item v-for="(item, idx) in Object.keys(total_view.store)" :key="idx">
                                            <template v-if="total_view.text_key_mapper[item] !== undefined">
                                            <span class="float-left">{{total_view.text_key_mapper[item] }}：</span>

                                            <span class="float-right mr-2" v-if="item.indexOf('average') === -1">{{total_view.store[item]}}</span>
                                            <span class="float-right mr-2" v-else>{{timeFormat(total_view.store[item])}}</span>
                                            </template>

                                        </b-list-group-item>
                                    </b-list-group>
                                </div>

                            </div>

                            <div>
                                <!-- 報表 -->
                                <b-table
                                    style="margin-top:1em;"
                                    :items="table_view.store.items" :fields="table_view.store.columns"
                                >
                                    <template v-slot:head()="data">
                                        <span 
                                            v-b-tooltip.hover :title="data.field.tooltip"
                                        >
                                            {{ data.label }}
                                            <i  
                                                v-if="data.field.tooltip !== undefined" 
                                                class="bi bi-info-circle">
                                            </i>
                                        </span>
                                    </template>


                                    <template v-slot:cell(average_response_time)="{ item }">
                                        <span 
                                        >
                                            {{timeFormat(item.average_response_time)}}
                                        </span>
                                    </template>

                                    <template v-slot:cell(average_done_time)="{ item }">
                                        <span 
                                        >
                                            {{timeFormat(item.average_done_time)}}
                                        </span>
                                    </template>

                                </b-table>
                            </div>
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>

        <loading
        :show="loading_config.show"
        :label="loading_config.label">
        </loading>
    </div>
</template>    
<script>
    import {
        apiGetMerchantById,
        apiGetStoreById
    } from '@/api/AdminManage.js'

    // 當然是要用別人做好的輪子！
    
    // 載入中視窗
    import loading from 'vue-full-loading'

    // 日期選擇器
    import 'vue2-datepicker/locale/zh-cn';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    // 圖表套件
    import { Line as LineChartGenerator } from 'vue-chartjs/legacy'
    import {
        Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        LineElement,
        LinearScale,
        CategoryScale,
        PointElement
    } from 'chart.js'

    ChartJS.register(
        Title,
        Tooltip,
        Legend,
        LineElement,
        LinearScale,
        CategoryScale,
        PointElement
    )

    export default {
        components: { DatePicker, loading, LineChartGenerator, },
        name: 'ReservationChart',
        data: function() {
            return {
                start_at: new Date(new Date().setDate(new Date().getDate() - 7)),
                end_at: new Date(),
                url_keys: [
                    'start_at', 'end_at', 'supplier_id', 'store_id', 'product_id'
                ],
                mode: 'supplier',
                chart_view: {
                    admin: {
                        labels: [
                            'January',
                            'February',
                            'March',
                            'April',
                            'May',
                            'June',
                            'July',
                        ],
                        datasets: [
                            {
                                label: '未完成預約',
                                backgroundColor: '#fe6483',
                                borderColor: '#fe6483',
                                data: [],
                            },
                            {
                                label: '已完成預約',
                                backgroundColor: '#4bc0c0',
                                borderColor: '#4bc0c0',
                                data: []
                            }
                        ],
                    },
                    supplier: {
                        labels: [
                            'January',
                            'February',
                            'March',
                            'April',
                            'May',
                            'June',
                            'July',
                        ],
                        datasets: [
                            {
                                label: '未完成預約',
                                backgroundColor: '#fe6483',
                                borderColor: '#fe6483',
                                data: [],
                            },
                            {
                                label: '已完成預約',
                                backgroundColor: '#4bc0c0',
                                borderColor: '#4bc0c0',
                                data: []
                            }
                        ],
                    },
                    store: {
                        labels: [
                            'January',
                            'February',
                            'March',
                            'April',
                            'May',
                            'June',
                            'July',
                        ],
                        datasets: [
                            {
                                label: '未完成預約',
                                backgroundColor: '#fe6483',
                                borderColor: '#fe6483',
                                data: [],
                            },
                            {
                                label: '已完成預約',
                                backgroundColor: '#4bc0c0',
                                borderColor: '#4bc0c0',
                                data: []
                            }
                        ],
                    }
                },
                table_view: {
                    admin: {
                        columns: [
                            {
                                label: '供應商名稱',
                                key: 'name',
                                
                            },
                            {
                                label: '完成預約數',
                                key: 'success',
                                tooltip: '客人有和店家完成預約',
                                sortable: true,
                            },
                            {
                                label: '未完成預約數',
                                key: 'fail',
                                tooltip: '客人沒有完成預約',
                                sortable: true,
                            },
                            {
                                label: '總預約數',
                                key: 'total',
                                sortable: true,
                            },
                            {
                                label: '平均預約處理時間',
                                key: 'average_response_time',
                                tooltip: '客人從開始預約到和店家約好服務時間所花的平均時間',
                                sortable: true,
                            },
                            {
                                label: '平均到店服務時間',
                                key: 'average_done_time',
                                tooltip: '客人從開始預約到實際到店服務所花的平均時間',
                                sortable: true,
                            }
                        ], 
                        items:[],
                    },
                    supplier: {
                        columns: [
                            {
                                label: '店家名稱',
                                key: 'name',
                                
                            },
                            {
                                label: '完成預約數',
                                key: 'success',
                                tooltip: '客人有和店家完成預約',
                                sortable: true,
                            },
                            {
                                label: '未完成預約數',
                                key: 'fail',
                                tooltip: '客人沒有完成預約',
                                sortable: true,
                            },
                            {
                                label: '總預約數',
                                key: 'total',
                                sortable: true,
                            },
                            {
                                label: '平均預約處理時間',
                                key: 'average_response_time',
                                tooltip: '客人從開始預約到和店家約好服務時間所花的平均時間',
                                sortable: true,
                            },
                            {
                                label: '平均到店服務時間',
                                key: 'average_done_time',
                                tooltip: '客人從開始預約到實際到店服務所花的平均時間',
                                sortable: true,
                            }
                        ], 
                        items:[],
                    },
                    store: {
                        columns: [
                            {
                                label: '課程名稱',
                                key: 'name',
                                
                            },
                            {
                                label: '完成預約數',
                                key: 'success',
                                tooltip: '客人有和店家完成預約',
                                sortable: true,
                            },
                            {
                                label: '未完成預約數',
                                key: 'fail',
                                tooltip: '客人沒有完成預約',
                                sortable: true,
                            },
                            {
                                label: '總預約數',
                                key: 'total',
                                sortable: true,
                            },
                            {
                                label: '平均預約處理時間',
                                key: 'average_response_time',
                                tooltip: '客人從開始預約到和店家約好服務時間所花的平均時間',
                                sortable: true,
                            },
                            {
                                label: '平均到店服務時間',
                                key: 'average_done_time',
                                tooltip: '客人從開始預約到實際到店服務所花的平均時間',
                                sortable: true,
                            }
                        ], 
                        items:[],
                    },
                },
                total_view: {
                    admin: {
                        success:0,
                        fail: 0,
                        total:0,
                        average_response_time: 0,
                        average_done_time: 0,
                    },
                    supplier: {
                        success:0,
                        fail: 0,
                        total:0,
                        average_response_time: 0,
                        average_done_time: 0,
                    },
                    store: {
                        success:0,
                        fail: 0,
                        total:0,
                        average_response_time: 0,
                        average_done_time: 0,
                    },
                    text_key_mapper: {
                        success: "完成預約數",
                        fail: "未完成預約數",
                        total: "預約總數",
                        average_response_time:"平均預約處理時間",
                        average_done_time: "平均到店服務時間"
                    }
                },
                selected_supplier: null,
                selected_store: null,

                lang: {
                    placeholder: {
                        date: '選擇日期'
                    }
                },
                loading_config: {
                    show: false,
                    label: '載入資料中'
                },
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false
                },
                merchant_session: JSON.parse(localStorage.getItem('merchant_session'))
            }
        },
        methods: {
            getReservation: async function(start_at, end_at, mode, supplier_id, store_id) {
                this.loading_config.show = true
                // 預約資料
                let data = []
                // 開始時間
                start_at = start_at.toLocaleDateString().replaceAll('/', '-')
                // 結束時間
                end_at = end_at.toLocaleDateString().replaceAll('/', '-')

                let query = ''
                let params = {}
                do {
                    if (mode === 'store') {
                                query = this.getStoreQuery(
                                        start_at, end_at,  supplier_id, store_id
                        )
                        break
                    }
                    if (mode === 'supplier') {
                            query = this.getSupplierQuery(
                                    start_at, end_at, supplier_id
                        )
                        break
                    }

                } while(0)
                params = {
                    query: JSON.stringify(query),
                    start_at: start_at,
                    end_at: end_at,
                    token: this.merchant_session['token'],
                    user_id: this.merchant_session['user_id'],
                    mode: mode,
                    supplier_id: supplier_id,
                    store_id: store_id
                }
                const DIRECTUS_API_URL = 'https://directus.buty99.com/flows/trigger/3fe45155-a635-4391-a3ab-af7ec7300927'
                data = await fetch(DIRECTUS_API_URL, {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(params)
                })
                .then(res => res.json())
                .then(res => {
                    
                    if (res.ok === 1) {

                        let data = res.data.data.data.reservation
                        return data

                    } else {

                        this.loading_config.show = false
                        this.$bus.fnShowInfo(res.msg)
                        return []

                    }
                    
                })
                .catch(error => {
                    console.log(error)
                    return []
                })
                
                // 清理資料 buty_store是 null 或沒有request_create_time的
                // 沒有buty_store不能分類所以去掉
                // 沒有request_create_time 代表沒有請求預約所以去掉
                data = data.filter(function(item) {
                    return item.buty_store !== null && item.request_create_time !== null
                })
                this.loading_config.show = false
                return data
            },
            handleTableViewData: function(data, mode) {
                let result = []
                let key = ''
                let name = ''
                let data_mapper = {}
                let data_name_mapper = {}
                // 先分群
                data.forEach(function(reservation) {
                    switch (mode) {
                        case 'admin':
                            key = reservation.buty_store.merchant.id
                            name = reservation.buty_store.merchant.name
                            break
                        case 'supplier':
                            key = reservation.buty_store.store_id
                            name = reservation.buty_store.store_name
                            break
                        case 'store':
                            key = reservation.product.ns_id
                            name = reservation.product.product_cname
                            break
                    }

                    if (data_mapper[key] === undefined) {
                        data_mapper[key] = []
                    }
                    if (data_name_mapper[key] === undefined) {
                        data_name_mapper[key] = name
                    }

                    data_mapper[key].push(reservation)
                })

                // 分群完計算成功/失敗/全部預約數 和 平均等候時間、平均服務取得時間
                let data_keys = Object.keys(data_mapper)
                data_keys.forEach(function(data_key) {
                    let datas = data_mapper[data_key]
                    let tmp_data = {
                        id: data_key,
                        name: data_name_mapper[data_key],
                        success: 0,
                        fail: 0,
                        total: 0,
                        average_response_time: 0,
                        average_response: 0,
                        average_done_time: 0,
                        average_done: 0,
                    }
                    datas.forEach(function(reservation){
                        // 合計
                        tmp_data.total += 1
                        // 成功和失敗
                        if (reservation.commit_confirm_time !== null) {
                            tmp_data.success += 1
                        }
                        else {
                            tmp_data.fail += 1
                        }
                        // 先加總平均回應時間 和 有回應的人數
                        if (reservation.request_create_time !== null && reservation.commit_confirm_time !== null) {
                            tmp_data.average_response += 1
                            let start_at = new Date(reservation.request_create_time).getTime()
                            let end_at = new Date(reservation.commit_confirm_time).getTime()
                            tmp_data.average_response_time += end_at - start_at
                        }
                        // 先加總平均取得服務時間 和 有服務的人數
                        if (reservation.request_create_time !== null && reservation.rv_commit_time !== null) {
                            tmp_data.average_done += 1
                            let start_at = new Date(reservation.request_create_time).getTime()
                            let end_at = new Date(reservation.rv_commit_time).getTime()
                            tmp_data.average_done_time += end_at - start_at
                        }
                    })

                    // 算 平均回應時間/平均取得服務時間
                    let avg_response = tmp_data.average_response_time / tmp_data.average_response
                    let avg_done = tmp_data.average_done_time / tmp_data.average_done
                    
                    if (isNaN(avg_response)) {
                        avg_response = 0
                    }
                    else {
                        avg_response = Math.abs(avg_response)
                    }

                    if (isNaN(avg_done)) {
                        avg_done = 0
                    }
                    else {
                        avg_done = Math.abs(avg_done)
                    }
                    tmp_data.average_response_time = avg_response
                    tmp_data.average_done_time = avg_done

                    // 推進陣列
                    result.push(tmp_data)
                })

                return result
            },
            handleChartViewData: function(data) {
                let that = this
                let date_mapper = {}
                data.forEach(function(reservation){
                    // 以請求時間為基準
                    let date = new Date(that.$bus.getYYYYMMDD(new Date(reservation.request_create_time), '-')).getTime()
                    if (date_mapper[date] === undefined) {
                        date_mapper[date] = {
                            'success': 0,
                            'fail': 0
                        }
                    }

                    if (reservation.commit_confirm_time !== null) {
                        date_mapper[date].success += 1
                    }
                    else {
                        date_mapper[date].fail += 1
                    }

                    
                })

                // 日期由小到大排序
                let day_keys = Object.keys(date_mapper)
                day_keys.sort(function(a, b) {
                    return a - b;
                });

                // 分出成功和失敗的dataset
                let success_nums = []
                let fail_nums = []
                day_keys.forEach(function(day_key){
                    success_nums.push(date_mapper[day_key].success)
                    fail_nums.push(date_mapper[day_key].fail)
                })

                // 將日期從timestamp轉為日期
                day_keys = day_keys.map(function(day_key){
                    return that.$bus.getYYYYMMDD(new Date(parseInt(day_key)), '-')
                })

                return {
                    labels: day_keys,
                    datasets: [
                        {
                            label: '未完成預約',
                            backgroundColor: '#fe6483',
                            borderColor: '#fe6483',
                            data: fail_nums,
                        },
                        {
                            label: '已完成預約',
                            backgroundColor: '#4bc0c0',
                            borderColor: '#4bc0c0',
                            data: success_nums
                        }
                    ]
                }
            },
            handleTotalViewData: function(data) {
                let result = {
                    success:0,
                    fail: 0,
                    total:0,
                    average_response:0 ,
                    average_response_time: 0,
                    average_done: 0,
                    average_done_time: 0,
                }
                data.forEach(function(reservation) {
                    result.total += 1
                    if (reservation.commit_confirm_time !== null) {
                        result.success += 1
                    }
                    else {
                        result.fail += 1
                    }

                    // 先加總平均回應時間 和 有回應的人數
                    if (reservation.request_create_time !== null && reservation.commit_confirm_time !== null) {
                        result.average_response += 1
                        let start_at = new Date(reservation.request_create_time).getTime()
                        let end_at = new Date(reservation.commit_confirm_time).getTime()
                        result.average_response_time += end_at - start_at
                    }
                    // 先加總平均取得服務時間 和 有服務的人數
                    if (reservation.request_create_time !== null && reservation.rv_commit_time !== null) {
                        result.average_done += 1
                        let start_at = new Date(reservation.request_create_time).getTime()
                        let end_at = new Date(reservation.rv_commit_time).getTime()
                        result.average_done_time += end_at - start_at
                    }
                    
                })

                // 算 平均回應時間/平均取得服務時間
                let avg_response = result.average_response_time / result.average_response
                let avg_done = result.average_done_time / result.average_done
                
                if (isNaN(avg_response)) {
                    avg_response = 0
                }
                else {
                    avg_response = Math.abs(avg_response)
                }

                if (isNaN(avg_done)) {
                    avg_done = 0
                }
                else {
                    avg_done = Math.abs(avg_done)
                }
                
                result.average_response_time = avg_response
                result.average_done_time = avg_done

                delete result['average_done']
                delete result['average_response']

                return result

            },
            goSupplier: async function(item) {
                // console.log("goSupplier");
                // console.log(item)
                // 加變數
                let new_url = this.appendParamToUrl(window.location.href, 'supplier_id', item.id)
                window.history.pushState('', document.title,new_url);

                this.mode = 'supplier'
                // this.selected_supplier = {
                //     id: this.getQueryVariable('supplier_id'),
                //     name: await this.getSupplierNameById(this.getQueryVariable('supplier_id'))
                // }
                this.start_at = new Date(this.start_at)
                this.end_at = new Date(this.end_at)

                let data = await this.getReservation(
                    this.start_at, this.end_at, this.mode, 
                    this.getQueryVariable('supplier_id'), this.getQueryVariable('store_id')
                )
                console.log('取得資料',data)
                this.table_view[this.mode].items = this.handleTableViewData(data,this.mode)
                console.log('表格資料', this.table_view[this.mode].items)
                this.chart_view[this.mode] = this.handleChartViewData(data)
                console.log('圖表資料', this.chart_view[this.mode])
                this.total_view[this.mode] = this.handleTotalViewData(data)
                console.log('統計資料', this.total_view[this.mode])
            },
            goStore: async function(item) {
                console.log("goStore");
                console.log(item);
                // 加變數
                let new_url = this.appendParamToUrl(window.location.href, 'store_id', item.id)
                await window.history.pushState('', document.title, new_url);

                this.mode = 'store'
                this.selected_supplier = {
                    id: await this.getQueryVariable('supplier_id'),
                    // name: await this.getSupplierNameById(this.getQueryVariable('supplier_id'))
                    name: await this.merchant_session['merchant_name']
                }
                
                this.selected_store = {
                    id: await this.getQueryVariable('store_id'),
                    name: await item.name
                }

                // 如果登的是店家帳號，不能讓他可以看到其他分店的資訊
                // 如果登的是店家帳號，不是透過點擊到該分店的item變數會沒東西，直接到localStorage拿資訊
                if (this.merchant_session['is_super_manage'] === 0) {

                    this.selected_supplier = null
                    this.selected_store = {
                        id: await this.getQueryVariable('store_id'),
                        name: this.merchant_session['store_name']
                    }
                }
                
                console.log(this.selected_store)
                this.start_at = new Date(this.start_at)
                this.end_at = new Date(this.end_at)
                
                console.log(await this.getQueryVariable('store_id'));
                let store_id = await this.getQueryVariable('store_id')
                let data = await this.getReservation(
                    this.start_at, this.end_at, this.mode, 
                    await this.getQueryVariable('supplier_id'), store_id
                )
                console.log('取得資料',data)
                this.table_view[this.mode].items = this.handleTableViewData(data,this.mode)
                console.log('表格資料', this.table_view[this.mode].items)
                this.chart_view[this.mode] = this.handleChartViewData(data)
                console.log('圖表資料', this.chart_view[this.mode])
                this.total_view[this.mode] = this.handleTotalViewData(data)
                console.log('統計資料', this.total_view[this.mode])
            },
            back: async function(back_tab) {
                let data = []
                let new_url = ''
                this.mode = back_tab
                switch (back_tab) {
                    case 'admin':
                        this.selected_supplier = null
                        this.selected_store = null
                        new_url = this.removeParamToUrl(window.location.href, 'supplier_id')
                        new_url = this.removeParamToUrl(new_url, 'store_id')
                        data = await this.getReservation(
                            this.start_at, this.end_at, this.mode,
                        )
                        break;
                    case 'supplier':
                        new_url = this.removeParamToUrl(window.location.href, 'store_id')
                        this.selected_store = null
                        data = await this.getReservation(
                            this.start_at, this.end_at, this.mode,
                            this.getQueryVariable('supplier_id')
                        )
                        break
                }

                console.log('取得資料',data)
                this.table_view[this.mode].items = this.handleTableViewData(data,this.mode)
                console.log('表格資料', this.table_view[this.mode].items)
                this.chart_view[this.mode] = this.handleChartViewData(data)
                console.log('圖表資料', this.chart_view[this.mode])
                this.total_view[this.mode] = this.handleTotalViewData(data)
                console.log('統計資料', this.total_view[this.mode])

                window.history.pushState('', document.title, new_url);
            },
            getSupplierNameById: async function(supplier_id) {
                let param = {
                    supplier_id: supplier_id
                }
                let result = await apiGetMerchantById(param).then(function(resp){
                    let data = resp.data
                    console.log(data)
                    return data.data.merchant_name
                }).catch(function(error){
                    console.log(error)
                    return '找不到此ID對應的供應商'
                })
                return result
            },
            getStoreNameById: async function(store_id) {
                let param = {
                    store_id: store_id
                }
                let result = await apiGetStoreById(param).then(function(resp){
                    let data = resp.data
                    console.log(data)
                    return data.data.name
                }).catch(function(error){
                    console.log(error)
                    return '找不到此ID對應的分店'
                })
                return result 
            },
            timeFormat: function(average) {
                let result = ''
                if (average === 0) {
                    result = '無完成預約數可以計算'
                }
                else if (average < 1000) {
                    result = (average / 1000).toFixed(2) + '秒'
                }
                else if(average <= 60000) {
                    result = (average / 1000).toFixed(2) + '分'
                }
                else {
                    result = (average / 3600000).toFixed(2)

                    if (result > 24) {
                        result = (result / 24).toFixed(2) + '天'
                    }
                    else {
                        result = result  + '時'
                    }
                }
                return result
            },
            getSupplierQuery: function(start_at, end_at, supplier_id) {
                let query = `
                            query {
                            reservation(
                                    limit: -1
                                    filter: {
                                        _and: [
                                            {
                                                request_create_time: { 
                                                    _between: [ "${start_at}", "${end_at}"]
                                                }
                                            },
                                            {
                                                buty_store: {
                                                    merchant:{
                                                        id: {
                                                            _contains: "${supplier_id}"
                                                        }
                                                    }
                                                }
                                            },
                                        ]
                                    }
                                    sort: [ "request_create_time" ]
                                ) {
                                    id

                                    order {
                                        order_id
                                    }

                                    # 進線預約時間
                                    date_created

                                    # 敲定預約時間
                                    commit_confirm_time

                                    # 開始預約流程的時間
                                    request_create_time

                                    rv_commit_time

                                    # 店家id
                                    buty_store {
                                            merchant{
                                                id
                                                name
                                            }
                                            store_id
                                            store_name
                                            merchant_name
                                            longitude
                                    }
                                    product {
                                        product_cname
                                        ns_id
                                    }
                                }
                    }`

                return query
            },
            getStoreQuery: function(start_at, end_at, supplier_id, store_id) {
               let query = `
                            query {
                            reservation(
                                    limit: -1
                                    filter: {
                                        _and: [
                                            {
                                                request_create_time: { 
                                                    _between: [ "${start_at}", "${end_at}"]
                                                }
                                            },
                                            {
                                                buty_store: {
                                                    merchant:{
                                                        id: {
                                                            _contains: "${supplier_id}"
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                buty_store: {
                                                    store_id:{
                                                        _contains: "${store_id}"
                                                    }
                                                }
                                            },
                                        ]
                                    }
                                    sort: [ "request_create_time" ]
                                ) {
                                    id

                                    order {
                                        order_id
                                    }

                                    # 進線預約時間
                                    date_created

                                    # 敲定預約時間
                                    commit_confirm_time

                                    # 開始預約流程的時間
                                    request_create_time

                                    rv_commit_time

                                    # 店家id
                                    buty_store {
                                            merchant{
                                                id
                                                name
                                            }
                                            store_id
                                            store_name
                                            merchant_name
                                            longitude
                                    }
                                    product {
                                        product_cname
                                        ns_id
                                    }
                                }
                    }`

                return query
            },
            getData: async function() {
                let new_url = window.location.href
                this.start_at = new Date(this.start_at)
                this.end_at = new Date(this.end_at)
                console.log(this.$bus.getYYYYMMDD(this.start_at, '-'))
                new_url = this.appendParamToUrl(
                    new_url, 'start_at', this.$bus.getYYYYMMDD(this.start_at, '-')
                )
                new_url = this.appendParamToUrl(
                    new_url, 'end_at', this.$bus.getYYYYMMDD(this.end_at, '-')
                )
                window.history.pushState('', document.title, new_url);
                do {
                    if (this.getQueryVariable('supplier_id') && this.getQueryVariable('store_id')) {
                        this.mode = 'store'
                        this.goStore({id: this.getQueryVariable('store_id')})
                        break;
                    }
                    if (this.getQueryVariable('supplier_id') && !this.getQueryVariable('store_id')) {
                        this.mode = 'supplier'
                        this.goSupplier({id: this.getQueryVariable('supplier_id')})
                        break;
                    }
                    this.mode = 'admin'
                    window.history.pushState('', document.title, new_url);

                    let data = await this.getReservation(
                        this.start_at, this.end_at, this.mode, 
                    )
                    console.log('取得資料',data)
                    this.table_view[this.mode].items = this.handleTableViewData(data,this.mode)
                    console.log('表格資料', this.table_view[this.mode].items)
                    this.chart_view[this.mode] = this.handleChartViewData(data)
                    console.log('圖表資料', this.chart_view[this.mode])
                    this.total_view[this.mode] = this.handleTotalViewData(data)
                    console.log('統計資料', this.total_view[this.mode])

                }while(0)

            },
            
        },
        created: async function() {
            console.log("1");
            let that = this
            let new_url = window.location.href
            // let merchant_session = JSON.parse(localStorage.getItem('merchant_session'))
            // 讀取網址裡的start_at/end_at，沒有的話初始在網址上
            this.url_keys.forEach(function(key) {
                if (that.getQueryVariable(key)) {
                    console.log(key);
                    that[key] = that.getQueryVariable(key)
                }
            })
            
            switch (this.merchant_session['is_super_manage']) {
                case 0:
                    console.log('store');
                    this.mode = 'store'
                    new_url = await this.appendParamToUrl(new_url, 'store_id', this.merchant_session['store_id'])
                    new_url = await this.appendParamToUrl(new_url, 'supplier_id', this.merchant_session['supplier_id'])
                    console.log(this.selected_store);
                    console.log(this.selected_supplier);
                    this.selected_store = {
                        id: await this.getQueryVariable('store_id'),
                        name: this.merchant_session['store_name']
                    }
                    window.history.pushState('', document.title, new_url);
                    break;

                case 1:
                    console.log('supplier');
                    this.mode = 'supplier'
                    new_url = await this.appendParamToUrl(new_url, 'supplier_id', this.merchant_session['supplier_id'])
                    console.log(new_url);
                    this.selected_supplier = {
                        id: this.merchant_session['supplier_id'],
                        name: this.merchant_session['merchant_name']
                    }
                    console.log(this.selected_supplier);
                    window.history.pushState('', document.title, new_url);
                    break;

                default:
                    break;
            }

            
            do {
                
                if (this.getQueryVariable('supplier_id') && this.getQueryVariable('store_id')) {
                    console.log("store");
                    this.mode = 'store'
                    this.goStore({id: this.getQueryVariable('store_id')})
                    break;
                }
                if (this.getQueryVariable('supplier_id') && !this.getQueryVariable('store_id')) {
                    console.log("supplier");
                    this.mode = 'supplier'
                    this.goSupplier({id: this.getQueryVariable('supplier_id')})
                    break;
                }
                //this.mode = 'admin'
                this.start_at = new Date(this.start_at)
                this.end_at = new Date(this.end_at)

                let data = await this.getReservation(
                    this.start_at, this.end_at, this.mode, 
                )
                console.log('取得資料',data)
                this.table_view[this.mode].items = this.handleTableViewData(data,this.mode)
                console.log('表格資料', this.table_view[this.mode].items)
                this.chart_view[this.mode] = this.handleChartViewData(data)
                console.log('圖表資料', this.chart_view[this.mode])
                this.total_view[this.mode] = this.handleTotalViewData(data)
                console.log('統計資料', this.total_view[this.mode])

            }while(0)

        },
        mounted: async function() {
            // await this.getData(this.start_at, this.end_at)
        }
    }

</script>
<style scoped>
.filter_container {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
}
.chart-container > div {
    height: 100%;
}
</style>